// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var ImportEnrichmentRule$ReactHooksTemplate = require("./importEnrichmentRule.res.js");
var ImportEnrichmentRuleCodec$ReactHooksTemplate = require("./ImportEnrichmentRuleCodec.res.js");
var ImportEnrichmentRuleTypes$ReactHooksTemplate = require("./ImportEnrichmentRuleTypes.res.js");
var ImportEnrichmentFieldOptions$ReactHooksTemplate = require("./ImportEnrichmentFieldOptions.res.js");

var eventKey = (function(e){return e.key});

function shortenPath(path) {
  var parts = Js_string.split(".", path);
  var lastIndex = parts.length - 1 | 0;
  var segment = Belt_Array.get(parts, lastIndex);
  if (segment !== undefined && segment !== "") {
    return segment;
  } else {
    return path;
  }
}

function actionTargetLabel(action) {
  if (action.targetField === "") {
    return "field";
  } else {
    return action.targetField;
  }
}

function conditionSnippet(condition) {
  var path = shortenPath(condition.path);
  var match = condition.op;
  switch (match) {
    case "matches_format" :
        return path + " " + ImportEnrichmentRuleTypes$ReactHooksTemplate.opLabel(condition.op) + " (" + condition.format + ")";
    case "blank" :
    case "present" :
        break;
    case "regex_match" :
        return path + " " + ImportEnrichmentRuleTypes$ReactHooksTemplate.opLabel(condition.op);
    default:
      if (condition.value !== "") {
        return path + " " + ImportEnrichmentRuleTypes$ReactHooksTemplate.opLabel(condition.op) + " \"" + condition.value + "\"";
      } else {
        return path + " " + ImportEnrichmentRuleTypes$ReactHooksTemplate.opLabel(condition.op);
      }
  }
  return path + " " + ImportEnrichmentRuleTypes$ReactHooksTemplate.opLabel(condition.op);
}

function ruleSummary(rule) {
  var match = ImportEnrichmentRuleCodec$ReactHooksTemplate.parseDefinitionForForm(rule.definition);
  var actions = match[2];
  var conditions = match[1];
  var conditionCount = Belt_List.length(conditions);
  var actionCount = Belt_List.length(actions);
  var whenPart;
  if (conditions) {
    var extra = conditionCount > 1 ? " (+" + String(conditionCount - 1 | 0) + " more)" : "";
    whenPart = conditionSnippet(conditions.hd) + extra;
  } else {
    whenPart = "Runs for all records";
  }
  var thenPart;
  if (actions) {
    var extra$1 = actionCount > 1 ? " (+" + String(actionCount - 1 | 0) + " more)" : "";
    thenPart = " → set " + actionTargetLabel(actions.hd) + extra$1;
  } else {
    thenPart = "";
  }
  if (conditions) {
    if (actions) {
      return "IF " + whenPart + thenPart;
    } else {
      return whenPart + " • " + String(actionCount) + " action(s)";
    }
  } else if (actions) {
    return "Runs for all records" + thenPart;
  } else {
    return "No actions configured";
  }
}

function basePath(campaignId) {
  if (campaignId !== undefined) {
    return "/api/v1/campaigns/" + campaignId + "/import_enrichment_rules";
  } else {
    return "/api/v1/import_enrichment_rules";
  }
}

function fetchRules(dispatch, campaignId) {
  Js_promise.$$catch((function (param) {
          Curry._1(dispatch, {
                TAG: "SetRules",
                _0: /* [] */0
              });
          Curry._1(dispatch, {
                TAG: "SetLoading",
                _0: false
              });
          Curry._1(dispatch, {
                TAG: "SetNotification",
                _0: {
                  TAG: "Failure",
                  _0: "Failed to load import enrichment rules."
                }
              });
          return Promise.resolve();
        }), Js_promise.then_((function (rules) {
              Curry._1(dispatch, {
                    TAG: "SetRules",
                    _0: rules
                  });
              Curry._1(dispatch, {
                    TAG: "SetLoading",
                    _0: false
                  });
              return Promise.resolve();
            }), Http$ReactHooksTemplate.fetchGetJSONDecode(basePath(campaignId), (function (param) {
                  return Json_decode.field("data", (function (param) {
                                return Json_decode.field("import_enrichment_rules", (function (param) {
                                              return Json_decode.list(ImportEnrichmentRule$ReactHooksTemplate.decode, param);
                                            }), param);
                              }), param);
                }))));
}

function ruleSearchHaystack(rule) {
  return (rule.name + " " + ruleSummary(rule)).toLowerCase();
}

function ruleMatchesSearch(rule, searchTerm) {
  if (searchTerm === "") {
    return true;
  } else {
    return Js_string.includes(searchTerm, ruleSearchHaystack(rule));
  }
}

function filterRule(rule, state) {
  var searchTerm = state.searchTerm.trim().toLowerCase();
  var matchesSearch = ruleMatchesSearch(rule, searchTerm);
  var match = state.statusFilter;
  var matchesStatus;
  switch (match) {
    case "AllStatuses" :
        matchesStatus = true;
        break;
    case "EnabledOnly" :
        matchesStatus = rule.enabled;
        break;
    case "DisabledOnly" :
        matchesStatus = !rule.enabled;
        break;
    
  }
  var match$1 = state.scopeFilter;
  var match$2 = rule.appliesTo;
  var matchesScope;
  switch (match$1) {
    case "AllPipelines" :
        matchesScope = true;
        break;
    case "FeedOnly" :
        switch (match$2) {
          case "FeedImport" :
              matchesScope = true;
              break;
          case "SurveyTrigger" :
          case "Both" :
              matchesScope = false;
              break;
          
        }
        break;
    case "TriggerOnly" :
        switch (match$2) {
          case "SurveyTrigger" :
              matchesScope = true;
              break;
          case "FeedImport" :
          case "Both" :
              matchesScope = false;
              break;
          
        }
        break;
    case "BothOnly" :
        switch (match$2) {
          case "FeedImport" :
          case "SurveyTrigger" :
              matchesScope = false;
              break;
          case "Both" :
              matchesScope = true;
              break;
          
        }
        break;
    
  }
  if (matchesSearch && matchesStatus) {
    return matchesScope;
  } else {
    return false;
  }
}

function makeDiffSummary(originalPayloadJson, evaluatedJson) {
  var original = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(originalPayloadJson);
  var evaluated = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(evaluatedJson);
  var originalCustomer = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(Belt_Option.getWithDefault(Js_dict.get(original, "customer_details_data"), {}));
  var originalMoreDetails = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(Belt_Option.getWithDefault(Js_dict.get(original, "more_details"), {}));
  var evaluatedCustomer = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(Belt_Option.getWithDefault(Js_dict.get(evaluated, "customer_details_data"), {}));
  var evaluatedMoreDetails = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(Belt_Option.getWithDefault(Js_dict.get(evaluated, "more_details"), {}));
  var collectChanges = function (prefix, oldObj, newObj) {
    return Belt_Array.keepMap(Js_dict.entries(newObj), (function (param) {
                  var key = param[0];
                  var nextValue = Belt_Option.getWithDefault(JSON.stringify(param[1]), "null");
                  var prevValue = Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(oldObj, key), (function (prim) {
                              return JSON.stringify(prim);
                            })), "(empty)");
                  if (prevValue !== nextValue) {
                    return prefix + "." + key + ": " + prevValue + " -> " + nextValue;
                  }
                  
                }));
  };
  var changes = Belt_Array.concat(collectChanges("customer_details_data", originalCustomer, evaluatedCustomer), collectChanges("more_details", originalMoreDetails, evaluatedMoreDetails));
  if (changes.length === 0) {
    return "No field changes detected for this sample input.";
  } else {
    return "Changes:\n" + changes.join("\n");
  }
}

function fetchFieldOptions(dispatch, campaignId) {
  ImportEnrichmentFieldOptions$ReactHooksTemplate.$$fetch(campaignId, (function (options) {
          Curry._1(dispatch, {
                TAG: "SetFieldOptions",
                _0: options
              });
        }), (function (param) {
          
        }));
}

var decodeObject = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject;

var getString = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString;

exports.eventKey = eventKey;
exports.decodeObject = decodeObject;
exports.getString = getString;
exports.shortenPath = shortenPath;
exports.actionTargetLabel = actionTargetLabel;
exports.conditionSnippet = conditionSnippet;
exports.ruleSummary = ruleSummary;
exports.basePath = basePath;
exports.fetchRules = fetchRules;
exports.ruleSearchHaystack = ruleSearchHaystack;
exports.ruleMatchesSearch = ruleMatchesSearch;
exports.filterRule = filterRule;
exports.makeDiffSummary = makeDiffSummary;
exports.fetchFieldOptions = fetchFieldOptions;
/* Http-ReactHooksTemplate Not a pure module */
